import * as React from "react";

interface DocumentUserSummaryProps {
  documentUser: {
    user: UserSnakeModel
  }
}

export default function DocumentUserSummary(props: DocumentUserSummaryProps) {
  const {
    documentUser,
  } = props;

  return (
    <div className="panel">
      <h1>{documentUser.user.first_name} {documentUser.user.last_name}</h1>
      <p>{documentUser.user.email}</p>
    </div>
  );
}
